import { render } from "./boxy.vue?vue&type=template&id=7751965a&scoped=true"
import script from "./boxy.vue?vue&type=script&lang=js"
export * from "./boxy.vue?vue&type=script&lang=js"

import "./boxy.vue?vue&type=style&index=0&id=7751965a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7751965a"]])

export default __exports__